import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, Input, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { SliderItem } from 'src/app/interfaces/banners/banners.interface';
import SwiperCore, { SwiperOptions, Navigation, Pagination } from 'swiper';
import { SwiperComponent } from 'swiper/angular';

SwiperCore.use([Pagination, Navigation]);

@Component({
  selector: 'app-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.scss']
})
export class SliderComponent implements OnInit {

  @Input() item!: SliderItem;
  @Input() isHome: boolean = false;

  @ViewChild('swiperHero', { static: false }) swiperHero?: SwiperComponent;
  @ViewChild('swiperHeroMobile', { static: false }) swiperHeroMobile?: SwiperComponent;

  config: SwiperOptions = {
    autoplay: true,
    initialSlide: 0,
    slidesPerView: 1,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      clickable: true,
    },
    rewind: true
  };


  constructor(
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngOnInit(): void {}

  isValidUrl(url: string | null | undefined): boolean {
    if (!url) return false;
    const cleaned = url.trim().toLowerCase();
    return cleaned !== '' && cleaned !== 'null';
  }  

  getPictureItem(item: SliderItem): string {
    if (!isPlatformBrowser(this.platformId)) return '';
    const isMobile = window.innerWidth < 800;
    return item.benefit
      ? (isMobile ? item.benefit.photo_mobile : item.benefit.photo)
      : (isMobile ? item.photo_mobile : item.photo);
  }

  navigate(item: SliderItem): void {
    if (item.benefit) {
      const categoryName = this.categoryNameUrl(item.benefit.category?.name || item.category?.name || '');
      const benefitName = item.benefit.name;
      this.router.navigate([`/beneficios-y-descuentos/${categoryName}/${benefitName}`]);
    } else if (this.isValidUrl(item.url)) {
      if (!isPlatformBrowser(this.platformId)) return;
      window.open(item.url as string, '_blank');
    } else {
      console.error('URL inválida o vacía:', item.url);
    }
  }

  private categoryNameUrl(name: string): string {
    return name
      .toLowerCase()
      .replace(/\s+/g, '-')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

}
